import React from "react";
import { Form as DhxForm, Popup as DhxPopup } from "dhx-suite";
import { JsSettings } from "models";
import { capitalize } from "../utils/stringHelper";

interface SettingsWindowProps {
    settings: JsSettings;
    visible: boolean;
    onClose: () => void;
    onChange: (settings: JsSettings) => void;
    isDarkTheme: boolean;
}

const widgetsGroups: { [key: string]: { id: string, value: string }[] } = {};
remote.data.versions.reduce((acc, cur) => {
    if (!acc[cur.widget] ) {
        acc[cur.widget] = [];
    }
    acc[cur.widget].push({ id: cur.id, value: cur.value });
    return acc;
}, widgetsGroups);

const formConfig = {
    rows: [
        ...Object.keys(widgetsGroups).map(k => ({
            type: "select",
            id: k,
            labelInline: true,
            label: capitalize(k),
            css: "js-code-settings__head-row version-row",
            options: [
                { value: "", content: "off" },
                ...widgetsGroups[k].map(v => ({ value: v.id, content: v.value }))
            ]
        }))
    ]
};

export const JsSettingsWindow = ({
    onClose,
    visible,
    settings,
    onChange,
    isDarkTheme
}: SettingsWindowProps) => {
    const formRef = React.useRef<DhxForm>(new DhxForm(null, formConfig));
    const winRef = React.useRef<DhxPopup>(new DhxPopup({ css: "st-settings-popup dhx_widget--border-shadow" }));
    React.useEffect(() => {
        if (formRef.current && winRef.current) {
            if (visible) {
                winRef.current.attach(formRef.current as any);
                const btn = document.querySelector('[dhx_id="settings"]')! as HTMLElement;
                winRef.current.show(btn);
                setTimeout(() => {
                    winRef.current.show(btn);
                }, 100);
                winRef.current.events.on("afterHide", onClose);

                formRef.current.events.on("change", () => {
                    setImmediate(() => {
                        const value: {[key: string]: string} = formRef.current.getValue();
                        const settings: JsSettings = {
                            widgets: [...Object.entries(value)]
                                .filter(kv => kv[1] && kv[1] !== "off")
                                .map(kv => ({ name: kv[0], version: kv[1] }))
                        };
                        onChange(settings);
                    });
                });
            } else {
                winRef.current.hide();
            }
        }
    }, [visible]);

    React.useEffect(() => {
        if (formRef.current) {
            const formValue: {[key: string]: string} = { };

            settings.widgets.reduce((acc, cur) => {
                acc[cur.name] = cur.version;
                return acc;
            }, formValue);

            formRef.current.setValue(formValue);
        }
    }, [settings.widgets.join(","), visible]);

    React.useEffect(() => {
        if (isDarkTheme) {
            formRef.current.setConfig({ ...formRef.current.config, cellCss: "st-settings__form dark-theme" });
        } else {
            formRef.current.setConfig({ ...formRef.current.config, cellCss: "st-settings__form" });
        }
    }, [isDarkTheme]);
    return <></>;
};
